export const captainTheme = (parentTheme: any) => ({
    ...parentTheme,
});